import Vue from 'vue'
import Vuex from 'vuex'
import $http from '@/api/request'
Vue.use(Vuex)
const file = {
  state: {
    aliyunFileToken: null,
    aliyunTokenCount: null,
  },
  mutations: {
    setAliyunFileToken (state, token) {
      state.aliyunFileToken = token
    },
    setAliyunTokenCount (state, count) {
      state.aliyunTokenCount = count
    },
  },
  actions: {
    async retrieveToken ({ commit, state }) {
      let tokenCount = state.aliyunTokenCount
      file.mutations.setAliyunTokenCount(state, ++tokenCount)
      if (state.aliyunTokenCount > 1) {
        return
      }
      const url = '/USER-SERVER/sysconfig/fileUploadToken.magpie'
      const param = {}
      const res = await $http.post(url, param)
      file.mutations.setAliyunFileToken(state, res.data)
    },
  },
}

export default file
